import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  max-width: 440px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 0 auto;
  min-height: calc(100vh - 300px);
  justify-content: center;
`;

export const Emoji = styled.span`
  font-size: 30px;
`;

export const PrimaryText = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.black7};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const SecondaryText = styled.div`
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;

export const Link = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
`;
